import React, { useEffect, useState } from "react";
import { Modal, Form, Row, Col, Select, Upload, Input } from "antd";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { DelDocumentApi } from "api/getQuiz";
import {
  openNotificationWithIcon,
  validateMessages,
} from "../../../../Function";

const ModalDelDoc = ({
  open,
  onCancel,
  arrTypeQuestion,
  selectedGroup,
  fetchListExamMaterials,
  listBinaryImage,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
    var get_file = listBinaryImage
      ? listBinaryImage[0].image_name.split("_page_")[0]
      : "";
    form.setFieldsValue({
      question_type: selectedGroup,
      file: get_file,
    });
  }, [open]);

  const onFinish = (value) => {
    DelDocumentApi({
      question_type: selectedGroup,
    })
      .then((res) => {
        openNotificationWithIcon("success", res.data.message);
        form.resetFields();
        onCancel();
        fetchListExamMaterials({
          question_type: selectedGroup,
        });
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title="Xác nhận xóa tài liệu"
      style={{ minWidth: "300px" }}
      width={500}
      footer={false}
      bodyStyle={{ paddingTop: 6 }}
      className={"site-drawer-render-in-current-wrapper"}
      maskClosable={false}
    >
      <Form
        form={form}
        name="basic"
        layout={"vertical"}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        validateMessages={validateMessages}
      >
        <Row>
          <Col span={20} offset={2}>
            <Form.Item
              label="Nhóm thi"
              name="question_type"
              rules={[{ required: true }]}
            >
              <Select disabled>
                {arrTypeQuestion &&
                  arrTypeQuestion.map((item, index) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.note} ({item.loai_cau_hoi})
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={20} offset={2}>
            <Form.Item label="File tài liệu" name="file">
              <Input disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item wrapperCol={{ offset: 9, span: 12 }}>
          <Button type="danger" htmlType="submit" className={"m-2"}>
            Xóa
          </Button>
          <Button onClick={onCancel}>Thoát</Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalDelDoc;
